import { useRef, useEffect } from 'react';
import shallowEquals from 'shallowequal';
import deepEquals from 'fast-deep-equal';
export function usePreviousValue(value) {
    const cache = useRef(undefined);
    useEffect(() => {
        cache.current = value;
    }, [value]);
    return cache.current;
}
export function usePreviousEquals(value, equals = shallowEquals) {
    const previousValue = usePreviousValue(value);
    return equals(previousValue, value);
}
export function useOriginalCopy(value, equals = shallowEquals) {
    const cache = useRef(value);
    const equalsRef = useRef(equals);
    useEffect(() => {
        equalsRef.current = equals;
    }, [equals]);
    useEffect(() => {
        if (!equalsRef.current(cache.current, value)) {
            cache.current = value;
        }
    }, [value]);
    return equals(cache.current, value) ? cache.current : value;
}
export function useOriginalDeepCopy(value) {
    return useOriginalCopy(value, deepEquals);
}
//# sourceMappingURL=index.js.map